import { Injectable } from '@angular/core';
import { B2BUserRole, GlobalMessageService, GlobalMessageType, RoutingService, User } from '@spartacus/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { UserAccountFacade } from 'src/feature-libs/kn-br-user/kn-br-account/root/facade';

@Injectable({
  providedIn: 'root',
})
export class KnBrAdminGuard {
  constructor(
    protected userService: UserAccountFacade,
    protected routingService: RoutingService,
    protected globalMessageService: GlobalMessageService
  ) { }

  canActivate(): Observable<boolean> {
    return this.userService.get().pipe(
      filter((user: User) => user && Object.keys(user).length > 0),
      map((user) => (user as User & { roles?: string[] })?.roles),
      map((roles: string[]) => {
        const hasRole =
          Array.isArray(roles) && (roles.includes(B2BUserRole.ADMIN) || roles.includes('b2bpurchasingagentadmingroup'));

        if (!hasRole) {
          // routing as temporary solution until /organization won't
          // have set up proper permission on backend
          this.routingService.go({ cxRoute: 'users' });

          this.globalMessageService.add(
            { key: 'organization.notification.noSufficientPermissions' },
            GlobalMessageType.MSG_TYPE_WARNING
          );
        }

        return hasRole;
      })
    );
  }
}
